"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = void 0;
var merge_1 = require("../../util/merge");
var Store = /** @class */ (function () {
    /**
     * Constructs a new `Store`.
     *
     * @param state Serialized state JSON.
     * @param logger Bernie logger
     */
    function Store(state, logger, setupFunction) {
        if (state === void 0) { state = {}; }
        if (setupFunction === void 0) { setupFunction = function (cb) { return cb(); }; }
        var _this = this;
        // @ts-ignore:next-line
        var defaults = this.constructor['DEFAULTS'] || {};
        setupFunction(function () { return Object.assign(_this, defaults, state, { logger: logger }); });
    }
    /**
     * Creates a basic JSON object from the store, excluding
     * any fields provided in `excludedFields`.
     */
    Store.prototype.toJSON = function (ignoreAdditionalKeys) {
        if (ignoreAdditionalKeys === void 0) { ignoreAdditionalKeys = []; }
        if (!Array.isArray(ignoreAdditionalKeys)) {
            ignoreAdditionalKeys = ignoreAdditionalKeys.constructor === String ? [ignoreAdditionalKeys] : [];
        }
        var regexIgnorePrivate = /^_.+/;
        var simpleObject = __rest(this, []);
        var ignoreKeys = Object.keys(simpleObject)
            .filter(function (key) { return regexIgnorePrivate.test(key) || typeof simpleObject[key] === 'function'; })
            .concat(ignoreAdditionalKeys, 'logger');
        return (0, merge_1.withoutKeys)(ignoreKeys).merge({}, simpleObject);
    };
    return Store;
}());
exports.Store = Store;
//# sourceMappingURL=store.js.map